import axios from 'axios'
import {clarify} from "@/utils/clear";

class OrderApi {
  constructor() {
    this.endpoint = process.env.VUE_APP_BASE_API
  }

  list(body) {
    let params = new URLSearchParams(body ? clarify(body) : body)
    return axios.get(`${this.endpoint}/orders`, {params}).then(response => response.data)
  }

  get(orderId) {
    return axios.get(`${this.endpoint}/orders/get/${orderId}`, {}).then(response => response.data)
  }

  delete(orderId) {
    return axios.delete(`${this.endpoint}/orders/delete/${orderId}`, {}).then(response => response.data)
  }

  save(order) {
    return axios.post(`${this.endpoint}/orders/save`, order).then(response => response.data)
  }


  saveUsers(presentId, users) {
    const formData = new FormData();
    formData.append("users", users)
    return axios.post(`${this.endpoint}/orders/present/${presentId}/save/users`, formData).then(response => response.data)
  }
  
  getUsers(presentId) {
    return axios.get(`${this.endpoint}/orders/present/${presentId}/users`, {}).then(response => response.data)
  }

  usersExcel(presentId, body, prefix, suffix) {

    body.presentId = presentId;
    let params = new URLSearchParams(clarify(body));
    return axios.get(`${this.endpoint}/orders/download/users/excel`, {
      params,
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)

      link.download = prefix + ' 대상목록'+suffix+'.xlsx'
      link.click()
      URL.revokeObjectURL(link.href)
    });

  }

  excel(body, prefix, suffix) {

    let params = new URLSearchParams(body ? clarify(body) : body)

    return axios.get(`${this.endpoint}/orders/download/excel`, {
      params,
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      }
    }).then(response => {

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)

      link.download = prefix + ' 선물 신청 목록 '+suffix+'.xlsx'
      link.click()
      URL.revokeObjectURL(link.href)
    });

  }

  changeState(orders, state) {
    const formData = new FormData();
    formData.append("orders", orders)
    formData.append("orderType", state)
    return axios.post(`${this.endpoint}/orders/change/state`, formData).then(response => response.data)
  }

}


export default new OrderApi()
